var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4E4E4E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,60.9c-3.6,0-7.3-0.7-10.8-2.1c-14.5-5.9-21.5-22.5-15.6-37C14.8,11.6,24.1,4.9,35.1,4.1l4.3-0.3l-3.2,2.9 c-2.9,2.6-5.1,5.7-6.5,9.3c-2.6,6.3-2.5,13.2,0.1,19.4c2.6,6.2,7.6,11.1,13.8,13.7l0,0c3.6,1.5,7.4,2.1,11.2,1.8l4.3-0.3L56,53.6 C50.6,58.4,43.9,60.9,37,60.9z M31.1,7.7c-8,1.9-14.5,7.4-17.7,15.2c-5.3,13,1,27.8,14,33.1c7.8,3.2,16.3,2.3,23.2-2.1 c-2.8-0.3-5.5-0.9-8.1-2c-7-2.9-12.5-8.3-15.5-15.3c-2.9-7-3-14.7-0.1-21.7C27.9,12.3,29.4,9.9,31.1,7.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleMoon);
export default __webpack_public_path__ + "static/media/toggle_moon.b339ee90139094fe779f54a475e2af71.svg";
export { ForwardRef as ReactComponent };